// extracted by mini-css-extract-plugin
module.exports = {"container":"FullDealTermSlider_container__2kwsx","slider":"FullDealTermSlider_slider__1bJYr"};